module.exports = __webpack_public_path__ + "img/orange_095.8ec42b96.png";